var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-alert',{attrs:{"type":"error","value":!!_vm.error,"transition":"slide-y-reverse-transition"}},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]),(_vm.gameLoaded)?_c('div',[_c('game-board')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }